// extracted by mini-css-extract-plugin
export default {"alreadyLockedRate":"styles_alreadyLockedRate__NYto-","legalNoteLinks":"styles_legalNoteLinks__su+GA","lockButtonContainer":"styles_lockButtonContainer__xEomH"};